// en.ts
export default {
	language: {
		title: 'English',
		code: 'EN',
	},
	company: {
		name: 'The North Cycling Team',
		describe: 'Explore the most beautiful cycling routes in China with like-minded partners and experience unparalleled cycling fun. Make every ride an unforgettable adventure.',
		join: 'Join now',
		slogan: 'Exploring Boundless, Accompanying the North Cycling Team',
		
		
		
		contact: 'Contact',
		contact_us: 'Contact Us',
		contact_us_desp: 'No matter if you have any questions or suggestions, please feel free to contact us at any time. Our team will be dedicated to serving you.',
		contact_information: 'Contact Information',
		contact_follow_us: 'Follow Us',
	},
	header: {
		homePage: 'home',
		//############################################# 自行车
		bike: 'Bike',
		road_bike: 'RoadBike',
		mountain_bike: 'MountainBike',
		folding_bike: 'FoldingBike',
		kids_bike: 'KidsBike',
		//############################################# 配件
		accessory: 'Accessory',
		
		handlebar: 'Handlebar',
		car_bell: 'CarBell',
		car_lock: 'CarLock',

		brake: 'Brake',
		variable_speed: 'VariableSpeed',

		drivetrain: 'Drivetrain',
		crank: 'Crank',
		chain: 'Chain',
		pedal: 'Pedal',

		seat: 'Seat',
		seat_post: 'SeatPost',

		wheels: 'Wheels',
		wheel_set: 'WheelSet',
		stickers: 'Stickers',
		bicycle_pump: 'BicyclePump',
		//############################################# 服装/更多
		apparel: 'Apparel & More',
		helmets: 'Helmets',
		shoes: 'Shoes',
		clothing: 'Clothing',
		other: 'Other',
		//############################################# 促销
		bike_or_more: 'bike & more',
		//############################################# 促销
		sale: 'Sale',
		//############################################# 新闻资讯
		news_press_releases: 'News & Press',
		//############################################# 关于我们
		about: 'About',
		culture_and_values: 'Culture & Values',
		milestone: 'Milestone',
		leadership_team: 'LeadershipTeam',
		our_business: 'OurBusiness',
		security_check: 'SecurityCheck',
	},
	security_check: {
		title: 'Security Verification',
		description: 'Through our security verification system, you can verify the authenticity of products and ensure you purchase genuine items.',
	},
	website: {
		home: 'home',
		about: 'about',
		products: 'products',
		partnership: 'partnership',
		contact: 'contact',
	}
};
